import Vue from "vue";
import Toasted from "vue-toasted";

Vue.use(Toasted, { position: "bottom-right", duration: 3000, iconPack: "fontawesome" });